export { Domain, ENVIRONMENT_NAMES, PROTOCOL_PREFIX, WindowLocation } from './types'

export { canUseWindow } from './browserEnvironment'

export { isServer } from './serverEnvironment'

export { WindowEnvConfig } from './envConfigForClient'
